<template>
  <deferred-actions
      :message="this.$t('successMessages.alertHandled')"
      :timeout="30000"
      :open-action="() => handleOrUndoAlert()"
      :timeout-action="() => hideAlertIfNecessary()"
      :actions="{
          undo : {
            label : this.$t('dss.undo'),
            action : () => handleOrUndoAlert(true)
          },
     }"
     :toast-options="{
        icon: 'undo'
     }"
     v-slot="{ defer }"
  >
    <v-tooltip
        top
        v-if="state === 'handled' || handled"
    >
      <template v-slot:activator="{ on, attrs }">
              <v-icon
                  color="green"
                  v-bind="attrs"
                  v-on="on"
                  dark
                  class="handle-alert-button__icon ml-6"
              >
                mdi-check-bold
              </v-icon>
      </template>
      <span>{{ $t('alert.handled') }}</span>
    </v-tooltip>
    <v-btn
        v-else
        class="ml-4"
        fab
        text
        small
        right
        color="red"
        :disabled="hasReadOnlyAccess"
        @click="defer"
    >
      <v-icon
          dark
          class="handle-alert-button__icon"
      >
        mdi-close
      </v-icon>
    </v-btn>
  </deferred-actions>

</template>

<script>/**
 * Component HandleAlertButton.vue
 *
 * @module HandleAlertButton
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.1] app/src/APP_DASHBOARD/templates/components/Parts/HandleAlertButton.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

import DeferredActions from "./DeferredActions.vue";

export default {
  name: 'HandleAlertButton',
  components: {DeferredActions},
  props: {
    state: {
      type: String,
      required: true,
    },
    alert: {
      type: Object,
      required: true,
    },
    isRecent: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      handled: false,
    }
  },
  computed: {
    hasReadOnlyAccess() {
      return this.$store.getters['user/hasReadOnlyAccess']
    }
  },
  methods: {
    hideAlertIfNecessary() {
      this.$emit("handle-confirmed");
    },
    async handleOrUndoAlert(undo = false) {
      if (!undo && this.state === 'handled') return;

      const action = this.isRecent ? 'handleOrReactivateRecent' : 'handleOrReactivateAll';
      const success = await this.$store
        .dispatch(`alerts/${action}`, {alertId : this.alert.id, reactivate : undo});

      if (success) {
        this.handled = !undo
      }
    },
  },
};
</script>

<style lang="scss">
.theme--light.v-btn.v-btn--disabled {

  &.handled .handle-alert-button__icon {
    color: rgb(76, 175, 80) !important;
  }

}
</style>
